import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageName: '',
};

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    setPageName: {
      reducer(state, action) {
        state.pageName = action.payload;
      },
    },
    clearPage: {
      reducer(state) {
        state.pageName = '';
      },
    },
  },
});

/**
 * Selectors
 */
export const selectPageName = (state) => state.page.pageName;

/**
 * Actions and reducer exports
 */
export const { clearPage, setPageName } = pageSlice.actions;
export default pageSlice.reducer;
